export default {
  usuario: {
    value: '',
    maxlength: '8',
    required: true,
    state: null
  },
  senha: {
    value: '',
    maxlength: '8',
    required: true,
    state: null
  },
  eventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  urlBase: {
    value: null,
    maxlength: '80',
    required: true,
    state: null
  },
  informacoesCadastrais: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  renda: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  score: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  chequeSemFundo: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  pendencias: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  protestos: {
    value: null,
    maxlength: '100',
    required: false,
    state: null
  },
  socios: {
    value: null,
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros/SerasaParams/serasa-form.js